import React, { useState, useEffect } from 'react';
import constant from '../../constant';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import { toast } from 'react-toastify';
import { v2_categories, v2_channels, v2_plan_type, v2_siteLocations } from '../../actions/v2/masterData';
import { v2_all_user } from '../../actions/v2/user';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import RemarksSelect from '../common/RemarksSelect';

const CreatePlanApprovalForm = ({ projectId, onSubmit, projectName, data }) => {
    const [state, setState] = useState({
        inspectionName: { name: 'inspectionName', value: data ? data.INSPECTION_NAME : '', isRequired: true, error: '' },
        // inspectionNumber: { name: 'inspectionNumber', value: data ? data.INSPECTION_NUMBER : '', isRequired: false, error: '' },
        hullId: { name: 'hullId', value: data ? data.SHIP_ID : '', options: [], isRequired: true, error: '' },
        locationId: { name: 'locationId', value: data ? data.LOCATION_ID : '', options: [], isRequired: true, error: '' },
        categoryId: { name: 'categoryId', value: data ? data.CATEGORY_ID : '', options: [], isRequired: true, error: '' },
        description: { name: 'description', value: data ? data.DESCRIPTION : '', isRequired: false, error: '' },
        assignee: { name: 'assignee', value: data ? data.ASSIGNED_USER : '', isRequired: false, error: '' },
        scheduleDate: { name: 'scheduleDate', value: data ? data.SCHEDULE_DATE : '', isRequired: false, error: '' },
        acceptedDate: { name: 'acceptedDate', value: data ? data.ACCEPTED_DATE : '', isRequired: false, error: '' },


    });


    useEffect(() => {
        v2_ships(null, projectId, null).then((res) => {
            if (res.status) {
                if (res.status) {
                    setState(prev => ({
                        ...prev,
                        hullId: {
                            ...prev.hullId,
                            options: res.result.map((item) => {
                                return {
                                    ...item,
                                    id: item.ID,
                                    name: item.HULL_NUMBER + ' - ' + item.SHIP_NAME
                                }
                            }) || []
                        }
                    }))
                }
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })

        v2_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['categoryId']: {
                        ...prev['categoryId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.CATEGORY_NAME
                            }
                        }) || []
                    }
                }));
            }
        })
        v2_siteLocations().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['locationId']: {
                        ...prev['locationId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.LOCATION_NAME
                            }
                        }) || []
                    }
                }));
            }
        })

        v2_all_user().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['assignee']: {
                        ...prev['assignee'],
                        options: res.result.map((item) => {
                            return {
                                id: item.USER_ID,
                                name: item.FULL_NAME
                            }
                        }) || []
                    }
                }));
            }
        })


    }, [])


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const renderInput = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <input
                type="text"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const renderDate = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <input
                type="date"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const renderTextArea = (label, name, placeholder = '') => (
        <div className="col-md-12 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <textarea
                rows={2}
                type="text"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );

    const renderSelect = (label, name, options = []) => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <select
                name={name}
                value={state[name].value}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
            </select>
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            projectId,
            inspectionName: state.inspectionName.value,
            shipId: state.hullId.value,
            categoryId: state.categoryId.value,
            locationId: state.locationId.value,
            description: state.description.value,
            assignee: state.assignee.value,
            scheduleDate: state.scheduleDate.value,
            acceptedDate: state.acceptedDate.value,

            // inspectionNumber: state.inspectionNumber.value
        };

        onSubmit(payload)
    };


    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {renderInput('Inspection Name', 'inspectionName', 'Enter Inspection Name')}
                {/* {renderInput('Inspection Number', 'inspectionNumber', 'Enter Inspection Number')} */}
                {renderSelect('Hull', 'hullId', state.hullId.options)}
                {renderSelect('Location', 'locationId', state.locationId.options)}
                {renderSelect('Category', 'categoryId', state.categoryId.options)}
                {renderSelect('Assginee', 'assignee', state.assignee.options)}
                {renderDate('Schedule Date', 'scheduleDate', state.scheduleDate.options)}
                {renderDate('Accepted Date', 'acceptedDate', state.acceptedDate.options)}

                <RemarksSelect
                    label="Remark"
                    name="description"
                    value={state.description.value}
                    onChange={handleChange}
                    error={state.description.error}
                    required={state.description.isRequired}
                    placeholder="Enter remarks"
                />
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <Link
                    className="btn btn-danger text-white"
                    to={{
                        pathname: constant.Authedcomponent.inspectionProject.url,
                        state: {
                            projectId,
                            projectName,
                        },
                    }}
                >
                    Cancel
                </Link>

            </div>
        </form >
    );
};

export default CreatePlanApprovalForm;
